module.exports = __webpack_public_path__ + "static/img/ratio-guide.c01d67c.jpg";